import api from './api';

export const getLayerCatalog = () =>
  api.get('/api/geography/layers');

export const searchGeographicFeatures = (q, params = {}) =>
  api.get('/api/geography/features', { params: { q, ...params } });

export const uploadTraditionalLands = (tenantId, formData) =>
  api.post(`/api/geography/${tenantId}/upload-traditional-lands`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getManagedLayers = (tenantId) =>
  api.get('/api/geography/manage/layers', { params: tenantId ? { tenantId } : {} });

export const createManagedLayer = (data) =>
  api.post('/api/geography/manage/layers', data);

export const getManagedLayer = (layerId) =>
  api.get(`/api/geography/manage/layers/${layerId}`);

export const updateManagedLayer = (layerId, data) =>
  api.patch(`/api/geography/manage/layers/${layerId}`, data);

export const uploadManagedLayerVersion = (layerId, formData) =>
  api.post(`/api/geography/manage/layers/${layerId}/versions`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const activateManagedLayerVersion = (layerId, versionId, expectedRevision, rollback = false) =>
  api.post(`/api/geography/manage/layers/${layerId}/versions/${versionId}/activate`, {
    expectedRevision,
    rollback,
  });

export const getManagedLayerPreview = (layerId, versionId, params = {}) =>
  api.get(`/api/geography/manage/layers/${layerId}/versions/${versionId}/geojson`, { params });

export const getManagedVersionFields = (layerId, versionId) =>
  api.get(`/api/geography/manage/layers/${layerId}/versions/${versionId}/fields`);

export const updateManagedVersionFieldMapping = (layerId, versionId, mapping) =>
  api.patch(`/api/geography/manage/layers/${layerId}/versions/${versionId}/field-mapping`, mapping);

export const getAvailableGeographyLayers = (params = {}) =>
  api.get('/api/geography/catalog', { params });

export const searchManagedGeographyFeatures = (layerId, params = {}) =>
  api.get(`/api/geography/managed/${layerId}/features`, { params });

export const getManagedLayerGeoJson = (layerId, params = {}) =>
  api.get(`/api/geography/managed/${layerId}/geojson`, { params });

export const lookupGeographyPoint = (params) =>
  api.get('/api/geography/lookup', { params });
